import { observer } from "mobx-react-lite";
import copyToClipboard from "@lib-shared/lib/copy-to-clipboard";
import { AnalyticsHelper } from "core/lib/analytics";
import formatPhoneNumber from "core/lib/format-phone-number";
import { SearchResultItem } from "core/models/search-result-item";
import GetDirections from "./get-directions";

type SearchResultProps = {
  item: SearchResultItem;
}

const copyToInstallerDetailsToClipboard = (item: SearchResultItem) => {
  const mobile = formatPhoneNumber(item.mobile);
  const text = `Address: ${item.address}. Phone: ${mobile}`;

  copyToClipboard(text);
};

const SearchResult = observer<SearchResultProps>((props) => {
  const { item } = props;
  const { name, address, mobile, tel } = item;

  const phone = formatPhoneNumber(mobile || tel);

  const call = () => window.open(`tel:${phone}`, "_self");

  const { callInstaller, copyToClipboard } = AnalyticsHelper;
  const callAnalytics = callInstaller(name, phone);
  const copyToClipboardAnalytics = copyToClipboard(name, phone);

  //TODO: Call installer should be configurable / i18n.
  return <li>
    <section>
      <h6>{name?.toUpperCase()}</h6>

      {address && <address>{address}</address>}

      <span className="tel" {...callAnalytics}>
                Call installer: <a href={`tel:${phone}`}>{phone}</a>
            </span>
    </section>
    <section>
      <GetDirections {...props} />

      <i className="icon-copy-clipboard"
         title="copy address and telephone"
         {...copyToClipboardAnalytics}
         onClick={() => copyToInstallerDetailsToClipboard(item)} />

      <i className="icon-contact"
         {...callAnalytics}
         onClick={call} />
    </section>
  </li>
});

export default SearchResult;
